import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { MoreVert, DownloadForOffline } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import {
  hrmsEmployeeFliter,
  statusType,
  themes,
  drawerStyle,
} from "services/constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { showToast } from "services/utils/Status";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { setScreenUserId } from "services/Redux/HRPortal";
import { Loader } from "components/Loader";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useFetch } from "services/hooks/useFetch";
import sessionHandling from "services/utils/notificationUtils";
import { Info } from "@mui/icons-material";
import { tooltipStyleProps, formKeyText } from "services/constants/Styles";
import { CustomizedDatePicker } from "components/CustomComponents/CustomizedDatePicker";
import { useForm } from "react-hook-form";
import moment from "moment";
import { CreateUserEmployee } from "./CreateUserEmployee";
import { EditUserEmployee } from "./EditUserEmployee";
import dayjs from "dayjs";

const employeeHeader = [
  "Employee name",
  "Employee id",
  "User Code",
  "Department",
  "Company Name",
  "Email id",
  "Status",
  "Action",
];
export const EmployeeDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    domain,
    token,
    globalSearchValue,
    adminCompanyName,
    adminCompanyId,
    userDetails,
    topbarCompanyId,
  } = useSelector((state) => state.tokenReducer);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editDetails, setEditDetails] = useState(null);
  const [openDeactivatePopup, setOpenDeactivatePopup] = useState(false);
  const [openActivatePopup, setOpenActivatePopup] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [masterEmployee, setMasterEmployee] = useState([]);
  const [fetchUserDetails, setFetchUserDetails] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [departmentName, setDepartmentName] = useState("All Department");
  const [statusName, setStatusName] = useState("Active");
  const [departmentId, setDepartmentId] = useState("99999");
  const { result: allDepartmentDetails } = useFetch(
    `${domain}get-department/?user_id=${userDetails?.id}`
  );
  const { control, watch, handleSubmit, reset } = useForm({
    mode: "onBlur",
  });

  const containerRef = useRef(null);
  const departmentDetails = [
    {
      id: 99999,
      department_name: "All Department",
    },
    ...allDepartmentDetails,
  ];

  const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);

  useEffect(() => {
    if (topbarCompanyId) {
      setFetchUserDetails(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${domain}list/employee?company_id=${topbarCompanyId}&department_id=${departmentId}&status=${statusName}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setLoading(false);
          setEmployeeDetails(res);
          setMasterEmployee(res);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    if (fetchUserDetails) {
      fetchEmployeeDetails();
      setFetchUserDetails(false);
    }
  }, [
    adminCompanyId,
    departmentId,
    domain,
    fetchUserDetails,
    statusName,
    token,
    topbarCompanyId,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCreateOpen = () => {
    setIsCreatePanelOpen(true);
  };

  const handleCreateClose = () => {
    setIsCreatePanelOpen(false);
  };

  const handleViewOpen = (data) => {
    dispatch(setScreenUserId(data.user_id));
    localStorage.setItem("hrScreenUserId", data.user_id);
    setIsViewPanelOpen(true);
  };

  const handleViewClose = () => {
    setIsViewPanelOpen(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const deactivateEmployee = async () => {
    setButtonLoader(true);
    try {
      const response = await fetch(`${domain}deactivate/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          user_id: editDetails.user_id,
          status: "Inactive",
        }),
      });
      const res = await response.json();
      if (response.status === 201 && response.ok) {
        setAnchorEl(null);
        showToast("error", "User inactivated successfully");
        const field = "status";
        const updatedUsers = employeeDetails.map((element) => {
          if (element.user_id === editDetails.user_id) {
            return { ...element, [field]: "Inactive" };
          }
          return element;
        });
        setEmployeeDetails(updatedUsers);
        setFetchUserDetails(true);
        handleDeactivateDialogBox();
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
      handleDeactivateDialogBox();
    } finally {
      setButtonLoader(false);
    }
  };

  const activateEmployee = async () => {
    setButtonLoader(true);
    try {
      const response = await fetch(`${domain}deactivate/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          user_id: editDetails.user_id,
          status: "Active",
        }),
      });
      const res = await response.json();
      if (response.status === 201 && response.ok) {
        setAnchorEl(null);
        showToast("error", "User activated successfully");
        const field = "status";
        const updatedUsers = employeeDetails.map((element) => {
          if (element.user_id === editDetails.user_id) {
            return { ...element, [field]: "Active" };
          }
          return element;
        });
        setEmployeeDetails(updatedUsers);
        setFetchUserDetails(true);
        handleActivateDialogBox();
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
      handleActivateDialogBox();
    } finally {
      setButtonLoader(false);
    }
  };

  const reprocessAttendance = async () => {
    setButtonLoader(true);
    try {
      const response = await fetch(`${domain}reprocess/bio_metric/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          user_id: editDetails.user_id,
          employee_code: editDetails?.user_code,
          start_date: watch("start_date").format("YYYY-MM-DD"),
          end_date: dayjs().format("YYYY-MM-DD"),
        }),
      });
      const res = await response.json();
      if (response.ok) {
        setAnchorEl(null);
        showToast("success", res?.message);
        setFetchUserDetails(true);
        handleReprocessDialogBox();
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setButtonLoader(false);
    }
  };

  const handleDeactivateDialogBox = () => {
    setOpenDeactivatePopup(false);
    setAnchorEl(null);
  };

  const handleActivateDialogBox = () => {
    setOpenActivatePopup(false);
    setAnchorEl(null);
  };

  const handleReprocessDialogBox = () => {
    setOpenDialog(false);
    setAnchorEl(null);
    reset();
  };

  const handleCloseInfoDialog = () => {
    setOpenDialogBox(false);
  };

  useEffect(() => {
    const filteredResults = masterEmployee.filter((item) =>
      hrmsEmployeeFliter.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setEmployeeDetails(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterEmployee, page]);

  const navigateBulkImport = () => {
    dispatch(setGlobalSearchValue(""));
    history.push("/admin/hrzone/bulk/import");
  };

  const getEmployeeDetails = () => {
    if (employeeDetails.length !== 0) {
      let dataPreparation = [];

      employeeDetails?.forEach((element) => {
        let overAllData = {
          employeename: element?.user_name,
          employeeid: element?.employee_id,
          usercode: element?.user_code,
          ...(departmentName === "All Department" && {
            departmentname: element?.department,
          }),
          ...(adminCompanyName === "All Companies" && {
            companyname: element?.company_name,
          }),
          emailid: element?.email ? element.email : "N/A",
          status: element?.status ? element?.status : "N/A",
        };
        dataPreparation.push(overAllData);
      });

      if (dataPreparation.length !== 0) {
        const company = ["Company Name"];
        const departemntname = ["Department Name"];
        const status = ["Status"];
        const employeeCount = ["Employee Count"];
        const statusCount =
          statusName === "Active"
            ? `Total No. of Active Employee: ${masterEmployee?.length}`
            : statusName === "Inactive"
            ? `Total No. of Inactive Employee: ${masterEmployee?.length}`
            : statusName === "All"
            ? `Total Number of Employee: ${masterEmployee?.length}`
            : "";
        company.push(adminCompanyName);
        departemntname.push(departmentName);
        status.push(statusName);
        employeeCount.push(statusCount);

        const TableHead = [
          "Employee Name",
          "Employee Id",
          "User Code",
          // "Department",
          "Email Id",
          "Status",
        ];

        if (
          adminCompanyName === "All Companies" &&
          departmentName === "All Department"
        ) {
          TableHead.splice(3, 0, "Department Name");
          TableHead.splice(4, 0, "Company Name");
        } else if (adminCompanyName === "All Companies") {
          TableHead.splice(3, 0, "Company Name");
        } else if (departmentName === "All Department") {
          TableHead.splice(3, 0, "Department Name");
        }

        const replacer = (key, value) => (value === null ? "" : value);
        const header = Object.keys(dataPreparation[0]);
        let csv = dataPreparation.map((row) =>
          header
            .map((fieldName) => JSON.stringify(row[fieldName], replacer))
            .join(",")
        );

        csv.unshift(TableHead.join(","));
        csv.unshift(",");
        csv.unshift(employeeCount.join(","));
        csv.unshift(status.join(","));
        csv.unshift(departemntname.join(","));
        csv.unshift(company.join(","));

        csv = csv.join("\r\n");

        const ConvertData = csv;
        const element = document.createElement("a");
        const file = new Blob([ConvertData], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = "EmployeeReports.csv";
        document.body.appendChild(element);
        element.click();
      } else {
        showToast("error", "No data available");
      }
    } else {
      showToast("error", "No employee details available");
    }
  };

  const handleDepartmentName = (event, data) => {
    if (data) {
      setDepartmentId(data?.id);
      setDepartmentName(data?.label);
      setTimeout(function () {
        setFetchUserDetails(true);
      }, 150);
      setPage(0);
    } else {
      setDepartmentId("");
      setDepartmentName("");
    }
  };

  const handleStatusName = (event, data) => {
    if (data) {
      setStatusName(data?.name);
      setFetchUserDetails(true);
      setPage(0);
    } else {
      setStatusName("");
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  return (
    <>
      <React.Fragment>
        <Mui.Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={3}
          flexWrap="wrap"
        >
          <Mui.Grid item>
            <Mui.Stack direction="Row">
              <Mui.Box>
                <Mui.Typography variant="h6" fontWeight={600}>
                  Overview
                </Mui.Typography>
                <Mui.Typography variant="body2" color="text.secondary">
                  {moment().format("dddd Do MMMM, YYYY")}
                </Mui.Typography>
              </Mui.Box>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container>
          <Mui.Grid item xs={2} sx={{ padding: 1, paddingTop: 3 }}>
            <Mui.Typography>Department</Mui.Typography>
            <CustomAutoComplete
              dataList={departmentDetails.map((obj) => ({
                ...obj,
                label: obj.department_name,
              }))}
              selectedValue={departmentName}
              updateDataFunction={handleDepartmentName}
              placeHolder="Select the department name"
            />
          </Mui.Grid>
          <Mui.Grid item xs={2} sx={{ padding: 1, paddingTop: 3 }}>
            <Mui.Typography>Status</Mui.Typography>
            <CustomAutoComplete
              dataList={statusType.map((obj) => ({
                ...obj,
                label: obj.name,
              }))}
              selectedValue={statusName}
              updateDataFunction={handleStatusName}
              placeHolder="Select the status name"
            />
          </Mui.Grid>

          <Mui.Grid item xs={4.3}></Mui.Grid>
          <Mui.Grid
            item
            xs={3.2}
            sx={{
              paddingTop: 2,
              padding: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomButton
              actionFuntion={navigateBulkImport}
              actionName="Bulk Import"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton
              actionFuntion={handleCreateOpen}
              actionName="Add Employee"
              typeName="button"
            />
          </Mui.Grid>
          <Mui.Grid
            item
            xs={0.4}
            sx={{
              paddingTop: 2.5,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <Mui.IconButton
              onClick={() => {
                getEmployeeDetails();
              }}
              disabled={employeeDetails?.length === 0 ? true : false}
            >
              <DownloadForOffline
                size="large"
                sx={{ color: themes.downloadIconColor, fontSize: 40 }}
              />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            padding: 1,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Mui.Typography
            sx={{ paddingRight: 3, fontSize: 18, fontWeight: "bold" }}
          >
            {statusName === "Active" ? (
              <>Total No. of Active Employee: {masterEmployee?.length}</>
            ) : statusName === "Inactive" ? (
              <>Total No. of Inactive Employee: {masterEmployee?.length}</>
            ) : statusName === "All" ? (
              <>Total Number of Employee: {masterEmployee?.length}</>
            ) : null}
          </Mui.Typography>
        </Mui.Grid>

        {loading ? (
          <Loader info="Loading..." />
        ) : (
          <Mui.Grid container>
            <Mui.TableContainer
              component={Mui.Paper}
              ref={containerRef}
              sx={{
                width: "100%",
                maxHeight: { md: 710, lg: 710, xl: 710 },
                ml: 2,
                mr: 2,
              }}
            >
              <Mui.Table>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                    "& .MuiTableCell-root": {
                      height: "15px",
                      padding: "6px 35px",
                    },
                  }}
                >
                  <Mui.TableRow maxWidth="xl" align="left">
                    {employeeHeader.map((header) =>
                      header !== "Company Name" ? (
                        <Mui.TableCell
                          sx={{ color: themes.headLine, fontWeight: "bold" }}
                        >
                          {header}
                        </Mui.TableCell>
                      ) : adminCompanyName === "All Companies" ? (
                        <Mui.TableCell
                          sx={{ color: themes.headLine, fontWeight: "bold" }}
                        >
                          {header}
                        </Mui.TableCell>
                      ) : (
                        false
                      )
                    )}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {employeeDetails?.length === 0 ? (
                    <InfoMessage dataLength={masterEmployee} />
                  ) : (
                    employeeDetails
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((data, index) => (
                        <Mui.TableRow
                          key={data.id}
                          sx={{
                            "& .MuiTableCell-root": {
                              height: "15px",
                              padding: "6px 35px",
                            },
                          }}
                        >
                          <>
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={data?.user_name?.charAt(0).toUpperCase()}
                                  src={data.image_url}
                                />
                                <Mui.Typography
                                  sx={{
                                    paddingLeft: 1,
                                  }}
                                >
                                  {data.user_name ? data.user_name : "N/A"}
                                </Mui.Typography>
                              </Mui.Stack>
                            </Mui.TableCell>
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              {data?.employee_id ? data?.employee_id : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              {data?.user_code ? data?.user_code : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              {data?.department ? data?.department : "N/A"}
                            </Mui.TableCell>
                            {adminCompanyName === "All Companies" ? (
                              <Mui.TableCell
                                align="left"
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditDetails(data);
                                  handleViewOpen(data);
                                }}
                              >
                                {data?.company_name
                                  ? data?.company_name
                                  : "N/A"}
                              </Mui.TableCell>
                            ) : (
                              false
                            )}
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              {data?.email ? data?.email : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell
                              align="left"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditDetails(data);
                                handleViewOpen(data);
                              }}
                            >
                              {data?.status ? data?.status : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell align="left">
                              <Mui.IconButton
                                size="small"
                                onClick={(e) => {
                                  setEditDetails(data);
                                  setAnchorEl(e.currentTarget);
                                }}
                              >
                                <MoreVert
                                  size="small"
                                  sx={{
                                    color: themes.headLine,
                                    strokeWidth: 2,
                                  }}
                                />
                              </Mui.IconButton>

                              <Mui.Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                elevation={1}
                                transformOrigin={{
                                  horizontal: "right",
                                  vertical: "top",
                                }}
                                anchorOrigin={{
                                  horizontal: "right",
                                  vertical: "bottom",
                                }}
                              >
                                {editDetails?.status === "Active" ? (
                                  <Mui.MenuItem
                                    onClick={() => {
                                      setAnchorEl(null);
                                      setOpenDeactivatePopup(true);
                                    }}
                                  >
                                    Deactivate
                                  </Mui.MenuItem>
                                ) : (
                                  <Mui.MenuItem
                                    onClick={() => {
                                      setAnchorEl(null);
                                      setOpenActivatePopup(true);
                                    }}
                                  >
                                    Activate
                                  </Mui.MenuItem>
                                )}
                                <Mui.MenuItem
                                  onClick={() => {
                                    setAnchorEl(null);
                                    setOpenDialog(true);
                                  }}
                                >
                                  Reprocess Attendance
                                </Mui.MenuItem>
                              </Mui.Menu>
                            </Mui.TableCell>
                          </>
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
        )}

        {employeeDetails.length > 25 && (
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={employeeDetails.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}

        <Mui.Drawer
          anchor="right"
          open={isCreatePanelOpen || isViewPanelOpen}
          onClose={() => {
            isCreatePanelOpen ? handleCreateClose() : handleViewClose();
          }}
          sx={drawerStyle}
        >
          {isCreatePanelOpen ? (
            <CreateUserEmployee
              onClose={handleCreateClose}
              reCallApi={setFetchUserDetails}
            />
          ) : isViewPanelOpen ? (
            <EditUserEmployee
              onClose={handleViewClose}
              reCallApi={setFetchUserDetails}
            />
          ) : null}
        </Mui.Drawer>

        <GlobalDialogBox
          open={openDialogBox}
          handleCloseDialog={handleCloseInfoDialog}
          title="Warning"
        >
          <Mui.Typography>
            `To onboard an employee, please create a designation and leave the
            group before proceeding. Designations can be created by going to
            Administration {">"} Masters {">"} Add Designation. Leave group can
            be created by going to Team Zone {">"}Leave Group {">"}Add Leave
            Group`
          </Mui.Typography>
          <Mui.Grid
            container
            sx={{ justifyContent: "flex-end", paddingTop: 1 }}
          >
            <Mui.Button
              variant="contained"
              size="small"
              sx={{
                background: themes.primaryIndicator,
                color: themes.headLine,
                padding: 1,
              }}
              onClick={() => handleCloseInfoDialog()}
            >
              Ok
            </Mui.Button>
          </Mui.Grid>
        </GlobalDialogBox>
        <GlobalDialogBox
          open={openDeactivatePopup}
          handleCloseDialog={handleDeactivateDialogBox}
          title={"Deactivate the user"}
        >
          <Mui.Typography sx={{ fontSize: 22 }}>
            Do you want to deactivate the employee ?
          </Mui.Typography>
          <Mui.Grid
            container
            spacing={2}
            sx={{ justifyContent: "flex-end", paddingTop: 1 }}
          >
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => handleDeactivateDialogBox()}
                actionName="No"
                typeName="submit"
              />
            </Mui.Grid>
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => deactivateEmployee()}
                actionName="Yes"
                typeName="submit"
                disableAction={
                  openDeactivatePopup && buttonLoader ? buttonLoader : false
                }
              />
            </Mui.Grid>
          </Mui.Grid>
        </GlobalDialogBox>
        <GlobalDialogBox
          open={openActivatePopup}
          handleCloseDialog={handleActivateDialogBox}
          title={"Activate the user"}
        >
          <Mui.Typography sx={{ fontSize: 22 }}>
            Do you want to activate the user ?
          </Mui.Typography>
          <Mui.Grid
            container
            spacing={2}
            sx={{ justifyContent: "flex-end", paddingTop: 1 }}
          >
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => handleActivateDialogBox()}
                actionName="No"
                typeName="submit"
              />
            </Mui.Grid>
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => activateEmployee()}
                actionName="Yes"
                disableAction={
                  openActivatePopup && buttonLoader ? buttonLoader : false
                }
                typeName="submit"
              />
            </Mui.Grid>
          </Mui.Grid>
        </GlobalDialogBox>

        <GlobalDialogBox
          open={openDialog}
          handleCloseDialog={handleReprocessDialogBox}
          title={"Reprocess Attendance"}
        >
          <Mui.Grid container>
            <Mui.Grid item xs={5}>
              <Mui.Typography sx={formKeyText}>
                Start Date &nbsp;
                <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="ToDo">
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid item xs={7}>
              <CustomizedDatePicker
                name="start_date"
                control={control}
                required
                requiredMessage="Start date is required"
                placeholder="Select start date"
                minDate={dayjs(editDetails?.last_pay_date, "DD/MM/YYYY").add(
                  1,
                  "day"
                )}
                disableFuture
                handleDisabledFutureDate={true}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid
            container
            spacing={2}
            sx={{ justifyContent: "flex-end", paddingTop: 1 }}
          >
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => handleReprocessDialogBox()}
                actionName="No"
                typeName="submit"
              />
            </Mui.Grid>
            <Mui.Grid item>
              <CustomButton
                actionFuntion={handleSubmit(() => reprocessAttendance())}
                actionName="Yes"
                disableAction={
                  openDialog && buttonLoader ? buttonLoader : false
                }
                typeName="submit"
              />
            </Mui.Grid>
          </Mui.Grid>
        </GlobalDialogBox>
      </React.Fragment>
    </>
  );
};
